import Blockchain_nft_data_source_class from '../datasource/nft_data_source.js'
import Helper_class from '../../../libs/helpers.js'
import _ from 'underscore'
const async = require('async')

class Get_nft_data_for_owned_tokens_at_index_range_usecase {
  constructor () {
    this.NftDataSource = new Blockchain_nft_data_source_class()
    this.Helper = new Helper_class()
    this.NftInformation = class {
      constructor (
        tokenId,
        croppedBase64PngString,
        fullBase64PngString,
        complete,
        saleInformation,
        name,
        number,
        seriesId,
        artist,
        positionInformation,
        hasAlpha,
        colorIndex,
        completionStatus
      ) {
        this.tokenId = tokenId
        this.croppedBase64PngString = croppedBase64PngString
        this.fullBase64PngString = fullBase64PngString
        this.complete = complete
        this.saleInformation = saleInformation
        this.name = name
        this.number = number
        this.seriesId = seriesId
        this.artist = artist
        this.positionInformation = positionInformation
        this.hasAlpha = hasAlpha
        this.colorIndex = colorIndex
        this.completionStatus = completionStatus
      }
    }
  }

  async execute (startIndex, endIndex) {
    const nftDataInrange = await this.NftDataSource.fetchNftDataForAccountForOwnedTokenInIndexRange(
      startIndex,
      endIndex
    )

    var _this = this
    const returnData = await async.map(nftDataInrange, async function (
      nftInfo,
      callback
    ) {
      const mappedNftInfo = _this.createNftInformation(nftInfo)

      callback(null, mappedNftInfo)
    })

    return returnData
  }

  createNftInformation (nftInfo) {
    return new this.NftInformation(
      nftInfo.tokenId,
      nftInfo.croppedBase64PngString,
      nftInfo.fullBase64PngString,
      nftInfo.complete,
      null,
      nftInfo.name,
      nftInfo.number,
      nftInfo.seriesId,
      nftInfo.artist,
      nftInfo.positionInformation,
      nftInfo.hasAlpha,
      nftInfo.colorIndex,
      nftInfo.completionStatus
    )
  }
}

export default Get_nft_data_for_owned_tokens_at_index_range_usecase
